/* eslint-disable prettier/prettier */
import React from 'react';
import MainLayout from '../Layouts/Mainlayout';
import CampaignList from './CampaignList';

export default function Campaigns(): JSX.Element {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <CampaignList />
      </MainLayout>
    </div>
  );
}
